<span [ngSwitch]="field.uiTypeMetadata">
    <span *ngSwitchCase="'TEXTFIELD'">
        <ng-container [ngSwitch]="field.datatype">
            <span *ngSwitchCase="'GRID'">
                <grid-field [field]="field" [recordUpdateDisabled]="recordUpdateDisabled" [recordId]="record?.id"></grid-field>
            </span>
            <ng-container *ngSwitchCase="'ATTACHMENT'">
                <ng-container *ngTemplateOutlet="attachment"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'BOOLEAN'">
                <div class="row booleanFieldContainer">
                    <div class="col-5 booleanLabel" [title]="field.displayName">
                        <span [textContent]="field.displayName + ' :'"></span>
                    </div>
                    <span
                        *ngIf="field.isMandatory && field.message.errors.length === 0"
                        class="mat-form-field-subscript-wrapper requiredCls">
                        *Required
                    </span>
                    <div class="col-7 booleanValues">
                        <!-- Normal (unmasked) boolean: show radio group -->
                        <ng-container *ngIf="field.maskType !== 'FULL' && field.maskType !== 'PARTIAL'">
                            <material-radio-group
                                [radioOptions]="radioOptions"
                                [selectedValue]="field.value"
                                [disabled]="!enableField"
                                (selectionChanged)="field.value = $event; valueChanged($event); debounceEvent($event)"
                                [ariaLabelledBy]="field.displayName"
                                [radioButtonClassList]="['inputRadioButton', 'margin5px']"></material-radio-group>
                        </ng-container>
                        <!-- Masked boolean + sensitive data OFF: show disabled input with masked value -->
                        <ng-container *ngIf="field.maskType && field.disabled">
                            <material-input
                                [autofocus]="false"
                                [errors]="[]"
                                [required]="false"
                                [model]="field.value"
                                [title]="field.value || field.displayName"
                                [disabled]="true"
                                (modelChange)="field.value = $event"></material-input>
                        </ng-container>
                        <!-- Non-masked or masked + sensitive data ON: show radio group (editable) -->
                        <ng-container *ngIf="!field.maskType || !field.disabled">
                            <material-radio-group
                                                  [radioOptions]="radioOptions"
                                                  [selectedValue]="field.value"
                                                  [disabled]="!enableField"
                                                  (selectionChanged)="field.value = $event; valueChanged($event); debounceEvent($event)"
                                                  [ariaLabelledBy]="field.displayName"
                                                  [radioButtonClassList]="['inputRadioButton', 'margin5px']"></material-radio-group>
                        </ng-container>
                    </div>
                    <mat-error
                        class="mat-form-field-subscript-wrapper requiredCls"
                        *ngIf="field.message.errors"
                        [title]="field.message.errors[0]">
                        <span [textContent]="field.message.errors[0]"></span>
                    </mat-error>
                </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <ng-container *ngIf="field.hasMasterLookup">
                    <lib-masterlookup
                        [disabled]="!enableField"
                        [isMasterSearchDisabled]="!field.masterSearchEnabled"
                        [classList]="classList"
                        [field]="field"
                        [value]="field.value"
                        [errors]="field.message.errors"
                        [warnings]="field.message.warnings"
                        [required]="enableField ? field.isMandatory || field.isBusinessKey : false"
                        [masters]="record.masters"
                        [description]="field.description || field.displayName"
                        [fieldsMap]="fieldsMap"
                        (modelChange)="valueChanged($event); debounceEvent($event)"
                        (debounceEventHandler)="debounceEvent($event)"
                        lookupHint="lookupHint"></lib-masterlookup>
                </ng-container>
                <ng-container *ngIf="!field.hasMasterLookup">
                    <ng-container *ngIf="!enableField">
                        <material-input
                            [disabled]="!enableField"
                            [placeholder]="field.displayName"
                            [errors]="field.message.errors"
                            [title]="field.displayName"
                            [model]="field.value"
                            [classList]="classList"
                            [debounceAfter]="1000"
                            [type]="['INT', 'LONG', 'FLOAT', 'DOUBLE', 'DECIMAL'].includes(field.datatype) ? 'number' : 'text'"
                            [outputFormat]="field.valueDisplayFormat"
                            (modelChange)="valueChanged($event)"
                            [required]="false"
                            [warnings]="field.message.warnings"
                            [description]="field.description || field.displayName"
                            (debounceEventHandler)="debounceEvent($event)"></material-input>
                    </ng-container>
                    <ng-container *ngIf="enableField">
                        <material-input
                            [disabled]="!enableField"
                            [placeholder]="field.displayName"
                            [errors]="field.message.errors"
                            [title]="field.displayName"
                            [model]="field.value"
                            [classList]="classList"
                            [debounceAfter]="1000"
                            [type]="['INT', 'LONG', 'FLOAT', 'DOUBLE', 'DECIMAL'].includes(field.datatype) ? 'number' : 'text'"
                            [outputFormat]="field.valueDisplayFormat"
                            (modelChange)="valueChanged($event)"
                            [required]="field.isMandatory || field.isBusinessKey"
                            [warnings]="field.message.warnings"
                            [description]="field.description || field.displayName"
                            (debounceEventHandler)="debounceEvent($event)"></material-input>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
    </span>
    <span *ngSwitchCase="'TEXTAREA'">
        <ng-container *ngIf="!enableField">
            <material-textarea
                [disabled]="!enableField"
                [placeholder]="field.displayName"
                [errors]="field.message.errors"
                [title]="field.displayName"
                [model]="field.value"
                [classList]="classList"
                [debounceAfter]="1000"
                (modelChange)="valueChanged($event)"
                [description]="field.description || field.displayName"
                [required]="false"
                (debounceEventHandler)="debounceEvent($event)"></material-textarea>
        </ng-container>
        <ng-container *ngIf="enableField">
            <material-textarea
                [disabled]="!enableField"
                [placeholder]="field.displayName"
                [errors]="field.message.errors"
                [title]="field.displayName"
                [model]="field.value"
                [classList]="classList"
                [debounceAfter]="1000"
                (modelChange)="valueChanged($event)"
                [description]="field.description || field.displayName"
                [required]="field.isMandatory || field.isBusinessKey"
                (debounceEventHandler)="debounceEvent($event)"></material-textarea>
        </ng-container>
    </span>
    <span *ngSwitchCase="'DROPDOWN'">
        <ng-container *ngIf="!enableField">
            <app-assetlookup
                [disabled]="!enableField"
                [field]="field"
                [errors]="field.message.errors"
                [required]="false"
                [conditionalValue]="getConditionValue()"
                [service]="service"
                [description]="field.description || field.displayName"
                (modelChange)="valueChanged($event); debounceEvent($event)"></app-assetlookup>
        </ng-container>
        <ng-container *ngIf="enableField">
            <app-assetlookup
                [disabled]="!enableField"
                [field]="field"
                [errors]="field.message.errors"
                [required]="field.isMandatory || field.isBusinessKey"
                [conditionalValue]="getConditionValue()"
                [service]="service"
                [description]="field.description || field.displayName"
                (modelChange)="valueChanged($event); debounceEvent($event)"></app-assetlookup>
        </ng-container>
    </span>
    <span *ngSwitchCase="'DATE'">
        <ng-container *ngIf="!enableField">
            <material-input-date
                [disabled]="!enableField"
                [label]="field.displayName"
                [placeholder]="field.displayName"
                [title]="field.displayName"
                [model]="field.value"
                [errors]="field.message.errors"
                [classList]="classList"
                [formFieldClass]="'recordDateField'"
                [debounceAfter]="1000"
                [required]="false"
                [description]="field.description || field.displayName"
                [dateFormat]="field.outputFormat"
                [inputOnlyDisabled]="true"
                [dontEmitFirstEvent]="true"
                (modelChange)="valueChanged($event)"
                (debounceEventHandler)="debounceEvent($event)"></material-input-date>
        </ng-container>
        <ng-container *ngIf="enableField">
            <material-input-date
                [disabled]="!enableField"
                [label]="field.displayName"
                [placeholder]="field.displayName"
                [title]="field.displayName"
                [model]="field.value"
                [errors]="field.message.errors"
                [classList]="classList"
                [formFieldClass]="'recordDateField'"
                [debounceAfter]="1000"
                [required]="field.isMandatory || field.isBusinessKey"
                [description]="field.description || field.displayName"
                [dateFormat]="field.outputFormat"
                [inputOnlyDisabled]="true"
                [dontEmitFirstEvent]="true"
                (modelChange)="valueChanged($event)"
                (debounceEventHandler)="debounceEvent($event)"></material-input-date>
        </ng-container>
    </span>
    <span *ngSwitchCase="'PASSWORD'">
        <ng-container *ngIf="enableField">
            <material-input-password
                [disabled]="!enableField"
                [errors]="field.message.errors"
                [placeholder]="field.displayName"
                [title]="field.displayName"
                [model]="field.value"
                [classList]="classList"
                [debounceAfter]="1000"
                (modelChange)="valueChanged($event)"
                [required]="field.isMandatory || field.isBusinessKey"
                [description]="field.description || field.displayName"
                (debounceEventHandler)="debounceEvent($event)"></material-input-password>
        </ng-container>
        <ng-container *ngIf="!enableField">
            <material-input-password
                [disabled]="!enableField"
                [errors]="field.message.errors"
                [placeholder]="field.displayName"
                [title]="field.displayName"
                [model]="field.value"
                [classList]="classList"
                [debounceAfter]="1000"
                (modelChange)="valueChanged($event)"
                [required]="false"
                [description]="field.description || field.displayName"
                (debounceEventHandler)="debounceEvent($event)"></material-input-password>
        </ng-container>
    </span>
    <span *ngSwitchCase="'RADIOBUTTON'">
        <ng-container *ngIf="!enableField">
            <app-assetlookup
                [disabled]="!enableField"
                [field]="field"
                [errors]="field.message.errors"
                [required]="false"
                [warnings]="field.message.warnings"
                [conditionalValue]="getConditionValue()"
                [service]="service"
                (modelChange)="valueChanged($event); debounceEvent($event)"></app-assetlookup>
        </ng-container>
        <ng-container *ngIf="enableField">
            <app-assetlookup
                [disabled]="!enableField"
                [field]="field"
                [errors]="field.message.errors"
                [required]="field.isMandatory || field.isBusinessKey"
                [warnings]="field.message.warnings"
                [conditionalValue]="getConditionValue()"
                [service]="service"
                (modelChange)="valueChanged($event); debounceEvent($event)"></app-assetlookup>
        </ng-container>
    </span>
    <span *ngSwitchCase="'CHECKBOX'">
        <ng-container *ngIf="enableField">
            <material-group-checkbox
                [disabled]="!enableField"
                [menuName]="field.displayName"
                [classList]="classList"
                [options]="field.lookupValues && field.lookupValues.displayVsValue"
                [value]="field.value"
                [optionDisplayNameProperty]="'key'"
                [optionValueProperty]="'value'"
                [errors]="field.message.errors"
                [required]="field.isMandatory || field.isBusinessKey"
                [warnings]="field.message.warnings"
                [description]="field.description || field.displayName"
                [field]="field"
                [conditionalValue]="getConditionValue()"
                (onOptionsChanged)="valueChanged($event); debounceEvent($event)"></material-group-checkbox>
        </ng-container>
        <ng-container *ngIf="!enableField">
            <material-group-checkbox
                [disabled]="!enableField"
                [menuName]="field.displayName"
                [classList]="classList"
                [options]="field.lookupValues && field.lookupValues.displayVsValue"
                [value]="field.value"
                [optionDisplayNameProperty]="'key'"
                [optionValueProperty]="'value'"
                [errors]="field.message.errors"
                [required]="false"
                [warnings]="field.message.warnings"
                [description]="field.description || field.displayName"
                [field]="field"
                [conditionalValue]="getConditionValue()"
                (onOptionsChanged)="valueChanged($event); debounceEvent($event)"></material-group-checkbox>
        </ng-container>
    </span>
    <span *ngSwitchCase="'ATTACHMENT'">
        <ng-container *ngTemplateOutlet="attachment"></ng-container>
    </span>
    <span *ngSwitchCase="'GRID'">
        <grid-field [field]="field" [recordUpdateDisabled]="recordUpdateDisabled" [recordId]="record?.id"></grid-field>
    </span>
    <span *ngSwitchDefault>
        <span [textContent]="field.uiTypeMetadata"></span>
        <!-- field | json -->
    </span>
</span>

<ng-template #attachment>
    <span *ngIf="field.show" class="fieldAttachmentContainer !flex items-center">
        <span class="fieldAttachmentLabel requiredAttachment">
            <div class="fieldAttachmentLabelText">
                <span [textContent]="field.displayName"></span>
                <span class="material-symbols-outlined" *ngIf="field.description?.length > 0" [title]="field.description">info</span>
                :
            </div>
            <div
                class="fieldAttachmentRequiredText"
                [class.mat-error]="field.message.errors.length > 0 || field.message.warnings.length > 0"
                [class.mat-has-warning]="field.message.warnings.length > 0">
                <span
                    [textContent]="
                        field.message.errors.length > 0
                            ? field.message.errors
                            : field.message.warnings.length > 0
                            ? field.message.warnings
                            : field.isBusinessKey || field.isMandatory
                            ? '* required'
                            : ''
                    "></span>
            </div>
        </span>
        <span class="fieldAttachmentIcon align-middle" *transloco="let translate">
            <mat-icon [title]="translate('Attach File')" (click)="openAttachModal()">attach_file</mat-icon>
        </span>
    </span>
</ng-template>
